export default "__VITE_ASSET__Iu$QgpXQ__"